export default __webpack_public_path__ + "static/media/new-dashboard.a0c53540.png";